import { useMemo } from 'react';
import { Edit, useNotify, useRedirect } from 'react-admin';

import {
  CampaignForm,
  CampaignReferenceFormCoordinatorProvider,
  buildCampaignReferenceTransform,
  useCampaignReferenceFormCoordinator,
} from './CampaignCreate';

const CampaignEditInner = () => {
  const notify = useNotify();
  const redirect = useRedirect();
  const coordinator = useCampaignReferenceFormCoordinator();
  const transform = useMemo(() => buildCampaignReferenceTransform(coordinator), [coordinator]);

  return (
    <Edit
      mutationMode="pessimistic"
      transform={transform}
      mutationOptions={{
        onSuccess: (data: any) => {
          notify('Updated campaign');
          redirect('show', 'campaigns', data.id);
        },
      }}
    >
      <CampaignForm mode="Update" />
    </Edit>
  );
};

export const CampaignEdit = () => (
  <CampaignReferenceFormCoordinatorProvider>
    <CampaignEditInner />
  </CampaignReferenceFormCoordinatorProvider>
);
